"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageCache = void 0;
const SEPARATOR = '|';
class LocalStorageCache {
    constructor(namespace) {
        this.setNamespace(namespace);
    }
    setNamespace(namespace) {
        if (namespace.includes(SEPARATOR)) {
            throw new Error(`Namespace cannot contain the "${SEPARATOR}" character.`);
        }
        this.namespace = namespace;
    }
    async get(key) {
        const data = localStorage.getItem(this.getKey(key));
        if (!data) {
            return null;
        }
        const { value, expiration } = JSON.parse(data);
        if (new Date(expiration) <= new Date()) {
            await this.flush(key);
            return null;
        }
        return value;
    }
    async set(key, data, cacheTTLMs = 20000) {
        const dataPersistable = this.createPersistable(data, cacheTTLMs);
        localStorage.setItem(this.getKey(key), JSON.stringify(dataPersistable));
    }
    async flush(key) {
        localStorage.removeItem(this.getKey(key));
    }
    getKey(key) {
        return this.namespace ? `${this.namespace}${SEPARATOR}${key}` : key;
    }
    createPersistable(data, cacheTTLMs) {
        const expiration = new Date().getTime() + cacheTTLMs;
        return { value: data, expiration };
    }
}
exports.LocalStorageCache = LocalStorageCache;
